import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useTranslation } from 'react-i18next';
import SectionHeading from '../SectionHeading/SectionHeading';
import { headCellSx, headRowSx, tableContainerSx, tableSx } from '../../tableStyles';

// Static §4.1 point values (versioned config lives server-side in loyalty_earning_rule;
// this table is display copy only, Phase 1 scope).
const RULES = [
    { key: 'airportShuttle', outbound: 50, inbound: 60, roundTrip: 125 },
    { key: 'privateIndividual', outbound: 70, inbound: 70, roundTrip: 150 },
    { key: 'sharedIndividual', outbound: 60, inbound: 60, roundTrip: 135 },
    { key: 'exclusive', outbound: 75, inbound: 75, roundTrip: 160 },
    { key: 'airportShuttleKomfort', outbound: 55, inbound: 65, roundTrip: 130 },
    { key: 'a2b', outbound: 50, inbound: 50, roundTrip: null },
];

const PointsRules = () => {
    const { t } = useTranslation();

    return (
        <Box>
            <SectionHeading icon={TrendingUpIcon}>{t('loyalty.rules.title')}</SectionHeading>
            <TableContainer component={Paper} variant="outlined" sx={tableContainerSx}>
                <Table sx={tableSx}>
                    <TableHead>
                        <TableRow sx={headRowSx}>
                            <TableCell sx={headCellSx}>{t('loyalty.rules.service')}</TableCell>
                            <TableCell align="center" sx={headCellSx}>
                                {t('loyalty.rules.outbound')}
                            </TableCell>
                            <TableCell align="center" sx={headCellSx}>
                                {t('loyalty.rules.inbound')}
                            </TableCell>
                            <TableCell align="center" sx={headCellSx}>
                                {t('loyalty.rules.roundTrip')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {RULES.map((rule) => (
                            <TableRow key={rule.key}>
                                <TableCell>{t(`loyalty.rules.products.${rule.key}`)}</TableCell>
                                <TableCell align="center">{rule.outbound}</TableCell>
                                <TableCell align="center">{rule.inbound}</TableCell>
                                <TableCell align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                    {rule.roundTrip ?? '–'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default PointsRules;
